import React from "react";
import PropTypes from "prop-types";
import { noop } from "lodash-es";
import CheckboxIcon from "../../components/checkboxicon/CheckboxIcon";
import { useId } from "../../helpers/hooks";
var Checkbox = function Checkbox(_ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    name = _ref.name,
    label = _ref.label,
    _ref$onCheck = _ref.onCheck,
    onCheck = _ref$onCheck === void 0 ? noop : _ref$onCheck,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    tip = _ref.tip;
  var id = useId();
  var labelId = "tui-checkbox-".concat(id);
  return /*#__PURE__*/React.createElement("div", {
    className: "tui-checkbox",
    style: style
  }, /*#__PURE__*/React.createElement(CheckboxIcon, {
    id: labelId,
    onChange: function onChange(value) {
      onCheck(value);
      _onChange({
        target: {
          name: name,
          value: value,
          checked: value
        }
      });
    },
    onBlur: onBlur,
    checked: checked,
    disabled: disabled
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: labelId,
    "aria-label": label
  }, label)), tip ? /*#__PURE__*/React.createElement("div", {
    className: "tui-checkbox-tip"
  }, tip) : null);
};
Checkbox.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.node.isRequired,
  onCheck: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  style: PropTypes.object,
  tip: PropTypes.node
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map